import { combineReducers } from 'redux'
import { duck as homeDuck } from './home'
import { duck as commonDuck } from './common'
export const rootReducer = combineReducers({
  // TODO: 移除下面这一行，然后配置需要 combine 的 reducer
  ['homeDuck']: homeDuck.reducer,
  ['commonDuck']: commonDuck.reducer,
})
